import { render, staticRenderFns } from "./TextBlock.vue?vue&type=template&id=13e076b1&"
import script from "./TextBlock.vue?vue&type=script&lang=js&"
export * from "./TextBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageColumnTextBlockInner: require('/usr/src/motec/components/page/column/TextBlockInner.vue').default})
